










































































































































































































import settings from '../settings.coffee'
import queries from "@/gql/queries.coffee"
import mutations from "@/gql/mutations.coffee"
import moment from "moment"
import utils from '@/utils.coffee'
import Vue from 'vue'

moment.locale("fr")

export default {
    "name": "LogosSingleAnswer"
    props: {
        answer: Object,
        has_game_set: Boolean,
        game_set: Array,
        can_improve_answer: Boolean,
    }
    data: ()->
      return {
        generating: false,
        show_regenerating_modal: false,
        show_scores: false,
        error: null,
        saving: false,
        # best_answer: false,
        show_improve_modal: false,
        improve_text: "",
        regeneration_error: false
        regeneration_error_message: null
      }
    created: () ->
      # console.log("mounting")
      # this.best_answer = this.is_best_answer()
      # console.log(this.best_answer)
    computed:
      "can_save_scores": ()->
        self = this
        if self.answer.score_human_global_note != null && self.answer.score_human_style_respect != null && self.answer.score_human_answers_diversity != null &&  self.answer.score_human_review_context != null && self.answer.score_human_marketing != null && self.answer.score_human_no_hallucinations != null
          return true
        else
          return false
      "is_best_answer": () ->
        for game in this.game_set
          console.log("-------------")
          console.log("answer", this.answer.uid, "game", game.uid)
          console.log("game", game.uid, "answer1= ", game.answer1.uid, "answer2= ", game.answer2.uid)
          if ((game.best_answer!= null) && (this.answer.uid == game.best_answer.uid))
            return true
          else
            return false
    methods:
      "reset_and_save_scores": ()->
        self = this
        self.answer.score_human_global_note = null
        self.answer.score_human_style_respect = null
        self.answer.score_human_answers_diversity = null
        self.answer.score_human_review_context = null
        self.answer.score_human_marketing = null
        self.answer.score_human_no_hallucinations = null
        self.answer.score_human_comments = null
        self.saving = true
        # console.log("reset scores", this.answer)
        response = await self.$http.post(
          settings.graphqlApiUrl, 
          {
            query: mutations.gql_mutation_logosanswer_reset_scores(
              self.answer.uid, 
            )
          }
        )
        # console.log(response)
        disable = ()->
          self.saving = false
          self.show_scores = false
          # console.log("emit scores")
          self.$emit("scores-saved")
        setTimeout(disable, 250)
      "save_scores": ()->
        self = this
        self.saving = true
        # console.log("save score", this.answer)
        response = await self.$http.post(
          settings.graphqlApiUrl, 
          {
            query: mutations.gql_mutation_logosanswer_set_human_scores(
              self.answer.uid, 
              parseInt(self.answer.score_human_global_note), 
              parseInt(self.answer.score_human_style_respect), 
              parseInt(self.answer.score_human_answers_diversity), 
              parseInt(self.answer.score_human_review_context), 
              parseInt(self.answer.score_human_marketing), 
              parseInt(self.answer.score_human_no_hallucinations),
              self.answer.score_human_comments,
            )
          }
        )
        # console.log(response)
        disable = ()->
          self.saving = false
          self.show_scores = false
          # console.log("emit scores")
          self.$emit("scores-saved")
        setTimeout(disable, 250)
      "toggle_show_scores": ()->
        this.show_scores = !this.show_scores
      "generate_answer": ()->
        self = this
        self.generating = true
        response = await self.$http.post(settings.graphqlApiUrl, {query: mutations.review_generate_logos_answer(self.$store.state.selected_review_uid)})
        # console.log("GENERATE ANSWER", response)
        if response.ok
          # console.log(response.body)
          if response.body.data.review_generate_logos_answer.ok
            self.error = null
          else
            # console.log("ERROR", response.body.data.review_generate_logos_answer.msg)
            self.error = response.body.data.review_generate_logos_answer.msg
        else
          self.error = response.body.data

        self.generating = false
      "human_datetime": (value)->
        return moment(value).format('DD/MM/YYYY HH:mm:ss')
      "copy_to_clipboard": (answer_uid)->
        el = this.$refs["answer_"+answer_uid]
        text = el.value

        textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.$store.dispatch("notify",{
            level: "success",
            text: "Copié!",
            seconds: 2
        })
        
      "copy_to_answer": (answer_uid)->
        # console.log("copy_to_clipboard")
        this.error = null
        el = this.$refs["answer_"+answer_uid]
        # console.log(el)
        content = el.value
        target_id = "review_state_answer_writing_textarea_answer_fr_"+this.$store.state.selected_review_uid
        # find the target element in that order:
        # - StateAnswerWriring field
        # - StateAnswerTextValidation field (which is used for gatherings...)
        target_el = document.getElementById(target_id)
        if !target_el?
          target_el = document.getElementById('review_state_answer_text_validation_textarea_answer_fr_' + this.$store.state.selected_review_uid)

        # update review just to check if we can copy
        # last state in ["AnswerWriting", "AnswerTextValidation"]
        # await this.fetch_review()
        # if this.can_copy_answer
        if !target_el?
          this.error = "Nous n'avons pas trouvé le champ pour copier la réponse. Réssayez lorsque vous êtes à l'étape de rédaction de la réponse (ou de validation pour les groupes)."
        else
          content = el.value
          if target_el.value == "" || target_el.value == undefined
            this.$root.state_set_answer_content(content)
            this.error = null
          else
            this.error = "Réponse déjà saisie, veuillez l'effacer avant de copier/coller la réponse Logos."
        # else
        #   this.error = "Vous ne pouvez pas copier la réponse: le dernier état de l'avis n'est ni 'en cours de rédaction' ni 'en attente de validation'"
        if this.error is null
          for game in this.game_set
            uid = this.answer.uid.toString() 
            console.log(uid)
            console.log(uid) 
            if (game.answer1.uid == answer_uid) || (game.answer2.uid == answer_uid)
              query = mutations.update_game(game.uid, best_answer_id=null, best_button_pushed=null, copy_button_pushed=true, copied_answer_id=answer_uid)
              console.log(query)
              response = await Vue.http.post(settings.graphqlApiUrl, {query: query})
      "set_height": ()->
        self = this
        utils.debounce(
            ()->
                self.height = (window.innerHeight-65)+ "px"
                return
            , 500)
      "show_improve_answer": () ->
        this.show_improve_modal = true
      "collapse_improve_answer": ()->
        this.show_improve_modal = false
      "show_regenerating_answer": ()->
        this.show_regenerating_modal = true
      "collapse_regenarting_answer": ()->
        this.show_regenerating_modal = false
      "improve_answer": ()->
        self = this
        self.regeneration_error_message = null
        self.regeneration_error = false
        this.collapse_improve_answer()
        this.show_regenerating_answer()
        try
          response = await Vue.http.post(settings.graphqlApiUrl, {query: mutations.update_answer(this.answer.uid, improve_text=this.improve_text)})
          console.log("RESPONSE", response)
          payload = response.body.data.improve_answer
          if payload.ok
            self.$emit("trigger-fetch-answers")
            this.collapse_regenarting_answer()
          else
            this.collapse_regenarting_answer()
            self.regeneration_error_message = payload.msg
            self.regeneration_error = true
        catch error
          this.collapse_regenarting_answer()
          self.regeneration_error_message = """#{error.statusText} (#{error.status})"""
          self.regeneration_error = true
      "vote_for_best_answer": ()->
        self = this
        # console.log("Cette réponse est la meilleure")
        
        # ensure that all games are present
        query = mutations.review_ensure_all_games(review_id=this.$store.state.selected_review_uid)
        response = await Vue.http.post(settings.graphqlApiUrl, {query: query})
        
        for game in this.game_set
          uid = this.answer.uid.toString()  
          if (game.answer1.uid == uid) || (game.answer2.uid == uid)
            query = mutations.update_game(game.uid, best_answer_id=uid, best_button_pushed=true)
            console.log(query)
            response = await Vue.http.post(settings.graphqlApiUrl, {query: query})
        self.$emit("trigger-fetch-review")
      }
